<template>
    <div class="component-settings-data">
        <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <div class="el-card__header text-left border" slot="header" v-else>
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never">
                        <el-tabs v-model="activeTab">
                            <el-tab-pane label="Imports" name="imports">
                                <div class="row mt-20">
                                    <div class="col-12">
                                        <h4 class="mb-10">Manus</h4>
                                        <div style="display: flex; align-items: center;">
                                            <img src="@/assets/manus.jpg" height="50px">
                                            <el-button type="primary ml-20 mr-20" @click="syncManus" :disabled="checkLastSyncManus">Sync now</el-button>
                                            <p class="mb-0 mr-5-howrly">Last sync</p>
                                            <el-input style="width: auto" disabled :value="lastSync" class="mb-0"></el-input>
                                            <p class="mb-0 ml-5-howrly cursive" v-show="checkLastSyncManus">Synchronisation is available once every 60 minutes</p>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="Exports" name="exports">
                                <div class="row mt-20">
                                    <div class="col-12">
                                        <h4 class="mb-10">Export</h4>
                                        <el-form label-width="120px">
                                            <el-form-item label="Export">
                                                <el-select v-model="selectedEndpoint" placeholder="Select">
                                                    <el-option
                                                        v-for="item in endpoints"
                                                        :key="item.url"
                                                        :label="item.name |formatVariableName "
                                                        :value="item.name">
                                                    </el-option>
                                                </el-select>
                                                <span class="ml-5-howrly" v-if="selectedEndpoint !== 'Select an endpoint'">{{endpoints.find(x => x.name === selectedEndpoint).info}}</span>
                                            </el-form-item>
                                            <el-form-item label="Seperator">
                                                <el-select v-model="seperator" placeholder="Select">
                                                    <el-option
                                                        label="Semicolon"
                                                        value=";">
                                                    </el-option>
                                                    <el-option
                                                        label="Comma"
                                                        value=",">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                                <div class="row mt-20">
                                    <div class="col-12">
                                        <h4 class="mb-10">Stores</h4>
                                        <el-form label-width="120px">
                                            <el-form-item label="Manager">
                                                <el-select
                                                    v-model="managers"
                                                    filterable
                                                    :clearable=true
                                                    multiple
                                                    collapse-tags
                                                    placeholder="Filter managers"
                                                    @visible-change="managerSelectChange($event)"
                                                    @change="checkManagerSelect($event)">
                                                    <el-option
                                                        label="All managers"
                                                        value="all">
                                                    </el-option>
                                                    <el-option
                                                        v-for="item in $store.getters['general/getStoreInterests']"
                                                        :key="item.user_id"
                                                        :label="item.user_name"
                                                        :value="item.user_id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="Stores">
                                                <el-select
                                                    v-model="stores"
                                                    filterable
                                                    :clearable=true
                                                    multiple
                                                    collapse-tags
                                                    class="margin-left-xl"
                                                    placeholder="Filter stores"
                                                    @visible-change="storeSelectChange($event)"
                                                    @change="checkSelect($event)">
                                                    <el-option
                                                        label="All stores"
                                                        value="all">
                                                    </el-option>
                                                    <el-option
                                                        label="No stores"
                                                        value="none">
                                                    </el-option>
                                                    <el-option
                                                        v-for="item in $store.getters['general/getStores']"
                                                        :key="item.store_id"
                                                        :label="item.store_name"
                                                        :value="item.store_id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                                <div class="row mt-20" v-if="selectedEndpoint !== 'Select an endpoint'">
                                    <div class="col-12">
                                        <h4 class="mb-10">Parameters</h4>
                                        <el-form ref="paramForm" :model="form" :rules="rules" label-width="120px">
                                            <el-form-item v-for="item of getParameters" :key="item" :model="form" :prop="item" :label="item | formatVariableName">
                                                <el-input placeholder="Please input a value" v-model="form[item]"></el-input>
                                            </el-form-item>
                                        </el-form>
                                        <el-button type="primary" @click="generateExport">Export</el-button>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { getHeadersWithAccessToken, arrayToCSV } from '../../functions'
import axios from '@/services/axios.js'
import vue from 'vue'
export default {
    data () {
        return {
            activeTab: 'imports',
            endpoints: [],
            selectedEndpoint: 'Select an endpoint',
            managers: [],
            stores: [],
            loaded: false,
            form: {},
            seperator: ';',
            rules: {},
            lastSync: null
        }
    },
    computed: {
        getParameters () {
            let params = this.endpoints.find(x => x.name === this.selectedEndpoint).parameters
            let idx = params.indexOf('store_id')
            if (idx > -1) {
                params.splice(idx, 1)
            }
            this.setRules(params)
            return params
        },
        checkLastSyncManus () {
            let now = new Date()
            let diff = now - new Date(this.lastSync)
            return diff < (3600000 + 2 * 3600000) // Fix for GMT time difference, need to wait for backend to end timezone so that we can take that into account
        }
    },
    methods: {
        getLastSyncManus () {
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/sync?platform=manus', { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.lastSync = response.data.last_invoked
                })
                .catch(error => {
                    console.log(error)
                })
        },
        syncManus () {
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_SCHEDULER_API_BASE_URL_DEV : process.env.VUE_APP_SCHEDULER_API_BASE_URL) + '/sync?platform=manus', {}, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.lastSync = response.data.last_invoked
                })
                .catch(error => {
                    console.log(error)
                })
        },
        setRules (params) {
            for (let param of params) {
                vue.set(this.rules, param, [{ required: true, message: 'Please input a value', trigger: 'change' }])
            }
        },
        generateExport () {
            this.$refs['paramForm'].validate((valid) => {
                if (valid === true) {
                    let url = this.endpoints.find(x => x.name === this.selectedEndpoint).url
                    let data = { format: 'aod', store_id: this.stores }
                    for (let param in this.form) {
                        data[param] = this.form[param]
                    }
                    axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/export' + url, data, { 'headers': getHeadersWithAccessToken() })
                        .then(response => {
                            var today = new Date()
                            var dd = today.getDate()
                            var mm = today.getMonth() + 1
                            var yyyy = today.getFullYear()
                            let csv = arrayToCSV(response.data.data, this.seperator)
                            let data = encodeURI('data:text/csv;charset=utf-8,' + csv)
                            const link = document.createElement('a')
                            link.setAttribute('href', data)
                            link.setAttribute('download', String(this.selectedEndpoint) + '_export_' + String(dd) + '_' + String(mm) + '_' + String(yyyy) + '.csv')
                            link.click()
                        })
                        .catch(error => { console.log(error) })
                }
            })
        },
        storeSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the graphs
                this.$store.dispatch('graphFilter/updateStores', { 'stores': this.stores })
                this.managers = []
                this.$emit('filterChanged')
            }
        },
        managerSelectChange (event) {
            if (event === false) { // This means the modal is closed, so we want to reload the
                let data = []
                for (let m of this.managers) {
                    let stores = this.$store.state.general.storeInterests.find(x => x.user_id === m)['stores']
                    if (stores !== null && stores.length > 0) {
                        data.push(...stores)
                    }
                }
                data = Array.from(new Set(data))
                this.stores = data
                this.$store.dispatch('graphFilter/updateStores', { 'stores': data })
                this.$emit('filterChanged')
            }
        },
        checkSelect (stores) {
            if (stores.includes('all')) {
                this.stores = this.$store.getters['general/getStores'].map(s => s.store_id)
            } else if (stores.includes('none')) {
                this.stores = []
            }
        },
        checkManagerSelect (managers) {
            if (managers.includes('all')) {
                this.managers = this.$store.getters['general/getStoreInterests'].map(s => s.user_id)
            }
        }
    },
    mounted () {
        this.getLastSyncManus()
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/export/info?format=doa', { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.endpoints = response.data.data
            })
            .catch(error => {
                console.log(error)
            })

        let promiseList = [this.$store.dispatch('general/getStores'), this.$store.dispatch('general/getStoreInterests')]
        Promise.all(promiseList).then(response => {
            this.stores = this.$store.state.general.storeInterests.find(x => x.user_id === parseInt(localStorage.getItem('user_id')))['stores']
            this.managers = [parseInt(localStorage.getItem('user_id'))]
            this.$store.dispatch('graphFilter/updateStores', { 'stores': this.stores }).then(response => {
                this.loaded = true
            })
        })
    }
}
</script>

<style lang="scss">
.component-settings-data {
    .el-select {
        width: 250px;
    }
    .el-input {
        max-width: 250px;
    }
    .cursive {
        font-style: italic;
    }
}
</style>
